// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyB47tQJIbq0daIa2Ow4nWpjF-XxQaBsA44",
    authDomain: "wheelring-28ce4.firebaseapp.com",
    projectId: "wheelring-28ce4",
    storageBucket: "wheelring-28ce4.appspot.com",
    messagingSenderId: "69937507412",
    appId: "1:69937507412:web:79861fad539000d4f351c1",
    measurementId: "G-SWQHY1C9R8"
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
